export default [
  {
    title: 'Kendala',
    customicon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 18.4301H13L8.54999 21.39C7.88999 21.83 7 21.3601 7 20.5601V18.4301C4 18.4301 2 16.4301 2 13.4301V7.42999C2 4.42999 4 2.42999 7 2.42999H17C20 2.42999 22 4.42999 22 7.42999V13.4301C22 16.4301 20 18.4301 17 18.4301Z" stroke="#222222" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 14H12.009" stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 6V11" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `,
    resource: 'Kendala',
    action: 'manage',
    children: [
      {
        title: 'Tiket Kendala',
        icon: 'None',
        resource: 'Tiket Kendala',
        route: 'ticketing-user',
        action: 'manage',
      },
      {
        title: 'Monitoring Claim',
        icon: 'None',
        resource: 'Monitoring Claim',
        route: 'monitoring-claim',
        action: 'manage',
      },
    ],
  },
]
